module.exports = __webpack_public_path__ + "static/media/title.3a44ed5d.png";